export class GlobalConstants {
	
	public static STORAGE_KEY_TEILNEHMERSPEZIFISCHES : string = "Teilnehmerspezifisches";
	public static STORAGE_KEY_RECHTLICHES : string = "Rechtiches";
	public static STORAGE_KEY_TEILNEHMERKENNUNG : string = "Teilnehmerkennung";
	public static STORAGE_KEY_AKTUELLE_VERSION : string = "AktuelleVersion";
	public static STORAGE_KEY_CHECKLIST_INDEX : string = "checklistIndex";

	public static WINDOW_PROPERTY_GlobalValues : string = "eGENA-GlobalValues";
	public static WINDOW_PROPERTY_TranslationData : string = "eGENA-TranslationData";


}


// WEBPACK FOOTER //
// ./src/app/core/GlobalConstants.ts